import { http } from "../http-common";


const getActiveRoles = () => {
  return http.get(
    `/role-management/getActiveRoles?status=true`
  );
};
const getActiveRolesNew = (profile, countryCode) => {
  let q = `?status=true&isRolePage=true`;
  if (profile == "Global") {
    q += `&attribute=Global`
  }
  if (profile == "Local") {
    q += `&countryCode=${countryCode}`
  }
  return http.get(
    `/role-management/getActiveRoles${q}`
  );
};
const getActiveRolesNewUsers = (profile, countryCode) => {
  let q = `?status=true`;
  if (profile == "Global") {
    q += `&attribute=Global`
  }
  if (profile == "Local") {
    q += `&countryCode=${countryCode}&attribute=Local`
  }
  return http.get(
    `/role-management/getActiveRoles${q}`
  );
};
const getRole = () => {
  return http.get(`/role-management`);
};


const getCuringById = ({ id }) => {
  return http.get(
    `culture/{cuCultureId}?cuCultureId=${id}&pageNumber=0&pageSize=10`
  );
};

const updateRole = (data) => {
  return http.put(`/role-management`, data);
};


const createRole = (data) => {
  return http.post(
    `/role-management`, data
  );
};

const deleteManure = ({ id }) => {
  return http.delete(`/greenManure/${id}`)
}

// const searchCuringUnitName = ({
//   tobaccoGroup,
//   status,
//   isNew,
//   countryCode,
//   curingUnitName,
//   page,
//   size,
// }) => {
//   const params = {
//     tobaccoGroup,
//     status,
//     isNew,
//     countryCode,
//     curingUnitName,
//     pageNumber: page,
//     pageSize: size,
//   };
//   const filteredEntries = Object.entries(params).filter(([key, value]) => value != "");
//   let newParams = Object.fromEntries(filteredEntries);
//   newParams['pageNumber'] = params.pageNumber
//   return http.get('/curingunit/search', { params: newParams });
// };



const searchManureData = (keyword) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`);
};


const searchRole = (query) => {
  return http.get(`/role-management?keyword=${query}`);
};

const getAllCuringData = (countryCode) => {
  return http.get(`curingunit/allCuringUnits?countryCode=${countryCode}`);
};

const filterManure = (keyword, status) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}&status=${status}`);
};

const filterManureAutocomplete = (keyword) => {
  return http.get(`/greenManure/search?pageNumber=0&pageSize=10&keyword=${keyword}`);
};

const fetchDelegation = (batOneId) => {
  return http.get(`/delegation/${batOneId}`);
};
const updateDelegation = (data) => {
  return http.put(`/delegation/${data?.delegation}?username=${data?.delegatedByUser}`);
};



const getActiveRolesAdministrator = () => {
  return http.get(
    `/role-management/getActiveRoles?isAdministrator=true&status=true`
  );
};

const isSelfDelegation = (query) => {

  const params = new URLSearchParams();
  params.append("pageNumber", query.pageNumber);
  params.append("pageSize", query.size);
  if (query.status) {
    params.append("status", query.status);
  }


  return http.get(
    `delegation/${query?.batOneId}?isSelfDelegation=true&${params.toString()}`
  );
};

const otherDelegation = (query) => {
  
  const params = new URLSearchParams();
  params.append("pageNumber", query.pageNumber);
  params.append("pageSize", query.size);
  if (query.status) {
    params.append("status", query.status);
  }
  return http.get(
    `delegation/${query?.batOneId}?isSelfDelegation=false&${params.toString()}`
  );
};

///delegation/9b1deb4d-3b7d-4bad-9bdd-2b0d7b3dcb6d?username=jdk

// const updateDelegation = (batOneId) => {
//   return http.get(
//     `delegation/${batOneId}?isSelfDelegation=false`
//   );
// };

const RoleService = {
  getActiveRoles,
  getActiveRolesNew,
  getActiveRolesNewUsers,
  getRole,
  createRole,
  getAllCuringData,
  getCuringById,
  searchManureData,
  updateRole,
  deleteManure,
  searchRole,
  filterManure,
  filterManureAutocomplete,
  fetchDelegation,
  updateDelegation,
  getActiveRolesAdministrator,
  isSelfDelegation,
  otherDelegation
};
export default RoleService;

